module.exports = __webpack_public_path__ + "img/icon_set.2e0175b9.png";